import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2bc6630"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "username"
}, "เบอร์โทรศัพท์/รหัสสมาชิก", -1))
const _hoisted_4 = { class: "fv-plugins-message-container" }
const _hoisted_5 = { class: "fv-help-block" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "password"
}, "รหัสผ่าน", -1))
const _hoisted_8 = { class: "fv-plugins-message-container" }
const _hoisted_9 = { class: "fv-help-block" }
const _hoisted_10 = { class: "d-grid" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-end mb-3" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "javascript:;",
    class: "text-white fs-5 border-white border-bottom",
    "data-bs-toggle": "modal",
    "data-bs-target": "#bx_modal_reset_password"
  }, "ลืมรหัสผ่าน")
], -1))
const _hoisted_12 = {
  tabindex: "3",
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn-sexy mb-5 mw-md-300px fs-4"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " เข้าสู่ระบบ ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ForgotPasswordModal = _resolveComponent("ForgotPasswordModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Form, {
        class: "form mw-md-400px mx-auto",
        id: "kt_login_signin_form",
        onSubmit: _ctx.onSubmitLogin,
        "validation-schema": _ctx.login
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_Field, {
              tabindex: "1",
              class: "form-control",
              type: "text",
              name: "username",
              autocomplete: "off",
              placeholder: "เบอร์โทรศัพท์/รหัสสมาชิก",
              maxlength: "20"
            }),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_ErrorMessage, { name: "username" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_Field, {
              tabindex: "2",
              class: "form-control",
              type: "password",
              name: "password",
              autocomplete: "off",
              placeholder: "รหัสผ่าน"
            }),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_ErrorMessage, { name: "password" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("button", _hoisted_12, _hoisted_15, 512)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ]),
    _createVNode(_component_ForgotPasswordModal)
  ], 64))
}